module.exports = __webpack_public_path__ + "32f07730d791862d3dd34479d17f5f56.png";